import { inject, injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { ApiGroup, APP_API_TOKEN, IAppApi } from '../../api/app.api';

@injectable()
export class ClientsPageStore {
    @observable.ref apiGroups: ApiGroup[] = [];
    @observable.ref selectedApiGroup: ApiGroup | null = null;
    @observable selectedResourceOwner: string | null = null;
    @observable appId: string | undefined = undefined;
    @observable loading = false;

    constructor(@inject(APP_API_TOKEN) private readonly appApi: IAppApi) {
        makeObservable(this);
    }

    @action
    async load(apiGroupName: string, owner: string, appId: string | undefined): Promise<void> {
        this.loading = true;
        try {
            const config = await this.appApi.getApiConfiguration();
            runInAction(() => {
                this.apiGroups = config.apiGroups.filter(
                    apiGroup => apiGroup.assignedResourceOwners.length > 0,
                );
                this.selectedApiGroup =
                    this.apiGroups.find(apiGroup => apiGroup.name === apiGroupName) ?? null;
                this.selectedResourceOwner = owner;
                this.appId = appId;
                this.loading = false;
            });
        } catch {
            runInAction(() => {
                this.loading = false;
            });
        }
    }
}
